module.exports = __webpack_public_path__ + "img/exhibition-3.d7900a80.png";